import { MappedResult } from '../mapped/index.mjs';
import { Exclude } from './exclude.mjs';
// prettier-ignore
function FromProperties(P, U) {
    return globalThis.Object.getOwnPropertyNames(P).reduce((Acc, K2) => {
        return { ...Acc, [K2]: Exclude(P[K2], U) };
    }, {});
}
// prettier-ignore
function FromMappedResult(R, T) {
    return FromProperties(R.properties, T);
}
// prettier-ignore
export function ExcludeFromMappedResult(R, T) {
    const P = FromMappedResult(R, T);
    return MappedResult(P);
}
